import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -80
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }} className={`
        fixed top-0 left-0 right-0 z-50
        transition-all duration-500
        ${scrolled ? 'bg-void/80 backdrop-blur-xl border-b border-flame/10' : 'bg-transparent'}
      `} data-id="element-136">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between" data-id="element-137">
        <a href="#" className="flex items-center gap-3 group" data-id="element-138">
          <div className="relative" data-id="element-139">
            <div className="absolute -inset-1 bg-gradient-to-r from-flame/30 via-magenta/20 to-teal/30 rounded-lg blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-140" />
            <img src="https://cdn.magicpatterns.com/uploads/tMPwTWnudTgzcXXb9s6Bxw/Screenshot_2026-02-19_at_12.48.38_PM.png" alt="DMT Logo" loading="eager" decoding="async" className="relative h-10 w-auto rounded-md shadow-sm" data-id="element-141" />
          </div>
          <div className="hidden sm:flex flex-col" data-id="element-142">
            <span className="font-serif text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold via-flame-light to-gold tracking-wider leading-tight" data-id="element-143">
              DMT
            </span>
            <span className="text-white/40 text-[10px] font-sans tracking-widest uppercase" data-id="element-144">
              La Molécula de Dios
            </span>
          </div>
        </a>

        <div className="flex items-center gap-8" data-id="element-145">
          <a href="#libro" className="font-sans text-sm text-white/60 hover:text-flame-light transition-colors duration-300 tracking-wide" data-id="element-146">
            El Libro
          </a>
          <a href="#autores" className="font-sans text-sm text-white/60 hover:text-flame-light transition-colors duration-300 tracking-wide" data-id="element-147">
            Autores
          </a>
        </div>
      </div>
    </motion.nav>;
}